/*@flow*/
import fetchWithCache from 'lib/fetchWithCache';
import checkResponseStatus from 'lib/checkResponseStatus';
import Task from 'folktale/concurrency/task';

const mkUrl = ({
  userName,
  q,
  apiKey,
}: {
  userName: string,
  q: string,
  apiKey: ?string,
}) => {
  if (apiKey) {
    q = q + '&api_key=' + apiKey;
  }
  const sql = encodeURIComponent(q);
  return `https://${userName}.cartodb.com:443/api/v2/sql?q=${sql}`;
};
const VERSION = 1;
const CACHE_NAME = 'carto-data-' + VERSION;

type Fields = { [key: string]: { type: 'string' | 'number' } };

type CartoResponse<T> = {
  fields: Fields,
  rows: T[],
  errors: string[],
  time: number,
  total_time: number,
};

type Opts =
  | string
  | {|
      userName?: string,
      apiKey?: string,
    |};

export type Row = {
  [key: string]: any,
};

export function getCartoSQL<T: Row>(opts: Opts): Promise<CartoResponse<T>> {
  let o = { sql: '', apiKey: undefined, userName: undefined };
  if (typeof opts === 'string') {
    o = { ...o, sql: opts };
  } else if (typeof opts === 'object') {
    o = { ...o, ...opts };
  }

  const { userName, apiKey, sql } = o;
  const url = mkUrl({ userName: userName || 'swc28', q: sql, apiKey });

  const req = new Request(url, {
    method: 'get',
    headers: {
      Accept: 'application/json',
    },
  });

  return fetchWithCache(req, CACHE_NAME)
    .then(checkResponseStatus)
    .then(res => res.json());
}

export default (Task.fromPromised(opts => getCartoSQL<Row>(opts)): any);
